export default __webpack_public_path__ + "static/bg-dark4-a2b1cf78d91090593b0e324b57a7c0b3.jpg";